export const DRAWER_ORIGINS = {
  LEFT: 'left',
  RIGHT: 'right',
  BOTTOM: 'bottom'
};
